export default __webpack_public_path__ + "media/images/badge-level1-size12-076249b26e7db1079e8581d778b80667.png";